import { useMemo } from 'react'

import createContextFactory from '@/utils/factory'

import useAgentPairing from './hooks/useAgentPairing'
import useAgentRuntime from './hooks/useAgentRuntime'

const { Provider, useContext } = createContextFactory(() => {
  const runtime = useAgentRuntime()
  const pairing = useAgentPairing(runtime)

  return useMemo(() => ({ runtime, ...pairing }), [runtime, pairing])
})

export {
  Provider as AgentProvider,
  useContext as useAgent,
}
